module.exports = __webpack_public_path__ + "img/1526789833.4ae46946.jpg";